import Link from 'next/link'
import Image from 'next/image'

export default function AuthLogo() {
  return (
    <div className="mb-5">
      <a className="inline-flex" href="/">
        <div className="relative flex items-center border-violet-500 border-2 justify-center w-12 h-12 sm:w-16 sm:h-16 dark:border border-transparent rounded-2xl shadow-2xl dark:[background:linear-gradient(theme(colors.slate.900),_theme(colors.slate.900))_padding-box,_conic-gradient(theme(colors.slate.400),_theme(colors.slate.700)_25%,_theme(colors.slate.700)_75%,_theme(colors.slate.400)_100%)_border-box] dark:before:absolute dark:before:inset-0 dark:before:bg-slate-800/30 dark:before:rounded-2xl">
          <Image className="relative w-8 h-8 sm:w-[42px] sm:h-[42px]" src="/images/logovexub.png" width={42} height={42} alt="Vexub" />
        </div>
      </a>
    </div>
  )
}
